<template>
  <div class="main-container">
    <div class="bread">
      <router-link :to="{name:'ExamIndex'}">在线测评</router-link>
      <span class="slash">/</span>
      <span class="current">仿真模考</span>
    </div>
    <div class="select-tab">
      <div class="item">
        <div class="left">
          <p>考试类型：</p>
        </div>
        <div class="right">
          <ul>
            <li :class="exam_type == 0?'active':'' " @click="changeType(0)">全部</li>
            <li :class="exam_type == 2?'active':'' " @click="changeType(2)">正式考试</li>
            <li :class="exam_type == 1?'active':'' " @click="changeType(1)">模拟考试</li>
          </ul>
        </div>
      </div>
      <div class="item">
        <div class="left">
          <p>考试状态：</p>
        </div>
        <div class="right">
          <ul>
            <li :class="start_status == 0?'active':'' " @click="changeStatus(0)">全部</li>
            <li :class="start_status == 2?'active':'' " @click="changeStatus(2)">未开始</li>
            <li :class="start_status == 1?'active':'' " @click="changeStatus(1)">进行中</li>
            <li :class="start_status == 3?'active':'' " @click="changeStatus(3)">已结束</li>
          </ul>
        </div>
      </div>
      <div class="item">
        <div class="left">
          <p>参考状态：</p>
        </div>
        <div class="right">
          <ul>
            <li :class="done_status == 0?'active':'' " @click="changeDone(0)">全部</li>
            <li :class="done_status == 1?'active':'' " @click="changeDone(1)">已考</li>
            <li :class="done_status == 2?'active':'' " @click="changeDone(2)">未考</li>
          </ul>
        </div>
      </div>
      <div class="item">
        <div class="left">
          <p>考试分类：</p>
        </div>
        <div class="right">
          <div class="classify-wrap">
            <ul>
              <li :class="classify == 0?'active':'' " @click="changeClassify(0)">全部</li>
            </ul>
            <ul>
              <li
                :class="classify == item.id?'active':'' "
                @click="changeClassify(item.id)"
                v-for="item in classifyList"
                :key="item.id"
              >
                {{item.label}}
                <div v-if="classify == item.id&&subClassifyList.length>0" class="select-tab-arrow"></div>
              </li>
            </ul>
          </div>
          <div class="child" v-if="subClassifyList.length">
            <p
              :class="item.id === sub_classify?'active':'' "
              v-for="item in subClassifyList"
              :key="item.id"
              @click="changeSubClassify(item.id)"
            >{{item.label}}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="clear list">
      <div v-if="list.length>0">
        <ExamSimulationItem v-for="item in list" :key="item.id" :item="item" :showName="true"></ExamSimulationItem>
      </div>
      <div v-else class="empty">
      <div>
        <img src="../../images/exam/package/empty@2x.png" style="width:176px;" />
      </div>
      <div>请稍后，模考正在赶来的路上</div>
    </div>
    </div>
    <el-pagination
      background
      @current-change="handlePageChange"
      :current-page="page"
      :page-size="limit"
      layout="prev, pager, next"
      :total="total"
      v-if="total>limit"
    ></el-pagination>
  </div>
</template>
<script>
import ExamSimulationItem from "../../components/ExamSimulationItem.vue";
export default {
  name: "ExamSimulation",
  components: {
    ExamSimulationItem
  },
  data() {
    return {
      exam_type: 0,
      start_status: 0,
      done_status: 0,
      list: [],
      page: 1,
      limit: 6,
      total: 0,
      classify: 0,
      sub_classify: 0,
      classifyList: [],
      subClassifyList: []
    };
  },
  async created() {
    await this.getData();
  },
  methods: {
    async getData() {
      this.classifyList = (await this.$http.get("/api/app/exam/test/classify")).rows;
      let data = await this.$http.get(
        "/api/app/exam/packageSimulation?exam_type=" +
          this.exam_type +
          "&start_status=" +
          this.start_status +
          "&done_status=" +
          this.done_status + 
          "&classify_id=" + 
          (this.sub_classify || this.classify),
        {
          page: this.page,
          limit: this.limit
        }
      );
      this.list = data.list;
      this.total = data.total;
    },
    async changeClassify(id) {
      this.classify = id;
      if (id > 0) {
        this.subClassifyList =
          this.classifyList.filter(c => c.id == id)[0].children || [];
      } else {
        this.subClassifyList = [];
      }
      if (this.subClassifyList.length > 0) {
        this.sub_classify = this.subClassifyList[0].id;
      } else {
        this.sub_classify = 0;
      }
      this.page = 1;
      await this.getData();
    },
    async changeSubClassify(id) {
      this.sub_classify = id;
      this.page = 1;
      await this.getData();
    },
    async changeType(type) {
      this.exam_type = type;
      this.page = 1;
      await this.getData();
    },
    async changeStatus(status) {
      this.start_status = status;
      this.page = 1;
      await this.getData();
    },
    async changeDone(done) {
      this.done_status = done;
      this.page = 1;
      await this.getData();
    },
    async handlePageChange(page) {
      this.page = page;
      await this.getData();
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/varibles.scss";
.list {
  background-color: white;
  margin-top: 30px;
  padding: 24px;
  margin-bottom: 50px;
  padding-bottom: 0;
}
.select-tab {
  .right {
    .classify-wrap {
      display: flex;
    }
  }
  .item .right li {
    margin-left: 0;
    margin-right: 40px;
  }
}
.empty {
  text-align: center;
  padding: 100px 0;
  background-color: white;
  margin-top: 30px;
  font-size: 18px;
  color: #8c8c8c;
  margin-bottom: 50px;
  img {
    margin-bottom: 30px;
  }
}
</style>